import React from 'react';
import ReactDOM from 'react-dom';
import { Amplify } from 'aws-amplify';

import { amplifyV6Config } from './amplify-v6-config';
import configureServices from './configure-services';
import { sendBridgeLinkOpened } from './core/helpers/bridge-link-opened';
import './core/styles.css';
import App from './core/components/app';

Amplify.configure(amplifyV6Config);
configureServices();
sendBridgeLinkOpened();

// A tab opened before a deploy still lazy-loads route chunks by their old hashed URL, which no
// longer exists after the deploy. Reload once so the page picks up the current index.html and
// bundle. Once per tab session, so a genuine network failure surfaces instead of reload-looping.
const STALE_CHUNK_RELOAD_KEY = 'staff-fe:stale-chunk-reloaded';
window.addEventListener('vite:preloadError', (event) => {
  if (sessionStorage.getItem(STALE_CHUNK_RELOAD_KEY)) {
    return;
  }
  sessionStorage.setItem(STALE_CHUNK_RELOAD_KEY, '1');
  event.preventDefault();
  window.location.reload();
});

// Legacy root on purpose: keeps React 17 sync-render semantics for MobX/Formik (no createRoot yet).
ReactDOM.render(<App />, document.getElementById('root'));
